import React from 'react';
import { Flex } from '@chakra-ui/react';
import { AccountOptions } from './AccountOptions';
import { LogoHeader } from './LogoHeader';
import { OrganizationsSelect } from './OrganizationsSelect';
import { StatsMenu } from './StatsMenu';

export const NavSideBar = () => (
  <Flex
    data-testid="nav-sidebar"
    flexDirection="column"
    maxWidth="250px"
    minWidth="250px"
    borderRight="1px solid"
    borderColor="whiteAlpha.300"
    justifyContent="space-between"
    backgroundColor="primary.400"
    height="100%"
    zIndex={1}
    position="fixed"
  >
    <Flex flexDirection="column" padding={4}>
      <LogoHeader />
      <OrganizationsSelect marginTop={12} />
      <StatsMenu />
    </Flex>

    <AccountOptions marginBottom={4} />
  </Flex>
);
